var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('ZyroButton',{staticClass:"mode-button",class:{
			'mode-button--selected': _vm.isSelected && _vm.showSelected,
			'mode-button--border-radius': _vm.hasBorderRadius,
		},style:(_vm.computedStyles),on:{"click":function($event){return _vm.$emit('click', _vm.mode)}}},[_c('ZyroSvg',{staticClass:"mode-button__icon",class:("mode-button__icon--" + _vm.iconName),attrs:{"name":_vm.iconName}})],1),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }